import React from "react";
import { FiCheckCircle, FiArrowRight } from "react-icons/fi";
import "./RocketSection.css";
import { useTranslation } from "react-i18next";

function RocketSection() {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="rocket-section">
      <div className="rocket-card-glass">
        {/* LUEUR D'AMBIANCE */}
        <div className="ambient-glow"></div>

        {/* CONTENU TEXTE */}
        <div className="rocket-content">
          <h2>
            {t("rocket.title_start")}{" "}
            <span className="gradient-text">{t("rocket.title_end")}</span>
          </h2>

          <div className="rocket-grid">
            {/* ITEM 1 : ICO / STO (Structure complexe) */}
            <div className="feature-item">
              <FiCheckCircle className="check-icon" />
              <span>
                {t("rocket.f1_text1")}{" "}
                <span className="highlight">{t("rocket.f1_high1")}</span>{" "}
                {t("rocket.f1_text2")}{" "}
                <span className="highlight">{t("rocket.f1_high2")}</span>
              </span>
            </div>

            {/* ITEM 2 : Projet */}
            <div className="feature-item">
              <FiCheckCircle className="check-icon" />
              <span>
                {t("rocket.f2_text")}{" "}
                <span className="highlight">{t("rocket.f2_high")}</span>
              </span>
            </div>

            {/* ITEM 3 : Marque Blanche */}
            <div className="feature-item">
              <FiCheckCircle className="check-icon" />
              <span>
                {t("rocket.f3_text")}{" "}
                <span className="highlight">{t("rocket.f3_high")}</span>
              </span>
            </div>

            {/* ITEM 4 : Marketplace */}
            <div className="feature-item">
              <FiCheckCircle className="check-icon" />
              <span>
                {t("rocket.f4_text")}{" "}
                <span className="highlight">{t("rocket.f4_high")}</span>
              </span>
            </div>

            {/* ITEM 5 : Investisseur */}
            <div className="feature-item">
              <FiCheckCircle className="check-icon" />
              <span>
                {t("rocket.f5_text")}{" "}
                <span className="highlight">{t("rocket.f5_high")}</span>
              </span>
            </div>
          </div>

          <button className="contact-btn" onClick={scrollToContact}>
            {t("rocket.cta")} <FiArrowRight />
          </button>
        </div>

        {/* VISUEL FUSIONNÉ (IMAGE) */}
        <div className="rocket-visual-blended">
          <div
            className="blended-image"
            style={{
              backgroundImage:
                "url(https://images.unsplash.com/photo-1517976487492-5750f3195933?q=80&w=1000)",
            }}
          ></div>
        </div>
      </div>
    </section>
  );
}

export default RocketSection;
